import { object, string, TypeOf } from 'zod';

/* --------------------------------- Images --------------------------------- */

export const Images = object({
    thumbnail: string().optional(),
    hero: string().optional(),
    poster: string().optional(),
});
export type Images = TypeOf<typeof Images>;
